import { render, staticRenderFns } from "./od_photo_input.vue?vue&type=template&id=37f57b8d&scoped=true&"
import script from "./od_photo_input.vue?vue&type=script&lang=js&"
export * from "./od_photo_input.vue?vue&type=script&lang=js&"
import style0 from "./od_photo_input.vue?vue&type=style&index=0&id=37f57b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f57b8d",
  null
  
)

export default component.exports